import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import DualRange from "../DualRange";
import SelectTeam from "../SelectTeam-new/SelectTeam";
import Textarea from "../Textarea-new/Textarea";

const BuyerInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown,
  viewMode,
  deleted,
}) => {
  return (
    <div className="Buyer-info">
      <div className="Buyer-info_column">
        <Input
          className="Buyer-info_column_item"
          required
          valueType="text"
          name="FIRST_NAME"
          label="First Name"
          value={data.FIRST_NAME}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          required
          valueType="text"
          name="LAST_NAME"
          label="Last Name"
          value={data.LAST_NAME}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          valueType="phone"
          name="PHONE"
          label="Phone"
          value={data.PHONE}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          valueType="email"
          name="EMAIL"
          label="Email"
          value={data.EMAIL}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Buyer-info_column_item"
          data={data}
          optionsType="profiles"
          value={data.PROFILE}
          valueKey="PROFILE"
          label="Profile"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Buyer-info_column_item"
          data={data}
          optionsType="buyerStatus"
          value={data.STATUS}
          valueKey="STATUS"
          label="Buyer Status"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <div
          className={`Buyer-info_column_item last-modified ${
            deleted ? "deleted" : ""
          }`}
        >
          Last modified on: {data.LAST_MODIFIED}
        </div>
      </div>
      <div className="Buyer-info_column">
        {data.STATUS && (
          <React.Fragment>
            <Dropdown
              className="Buyer-info_column_item"
              dropdownType="multiple"
              optionKey="code"
              optionLabelKey="name"
              data={data}
              optionsType="category"
              value={data.CATEGORY}
              valueKey="CATEGORY"
              label="Category"
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            <Dropdown
              className="Buyer-info_column_item"
              optionKey="code"
              dropdownType="multiple"
              optionLabelKey="name"
              data={data}
              optionsType="type"
              value={data.TYPE}
              valueKey="TYPE"
              label="Type"
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            {data.TYPE === "STNL" && (
              <Dropdown
                className="Buyer-info_column_item"
                dropdownType="multiple"
                data={data}
                optionsType="subcategorySTNL"
                value={data.SINGLE_TENANT_SUBCATEGORY}
                valueKey="SINGLE_TENANT_SUBCATEGORY"
                label="Tenant Subcategory"
                handleParentChange={handleChangeDropdown}
                viewMode={viewMode}
                deleted={deleted}
              />
            )}
            {data.TYPE === "MT" && (
              <Dropdown
                className="Buyer-info_column_item"
                dropdownType="multiple"
                data={data}
                optionsType="subcategoryMT"
                value={data.MULTI_TENANT_SUBCATEGORY}
                valueKey="MULTI_TENANT_SUBCATEGORY"
                label="Tenant Subcategory"
                handleParentChange={handleChangeDropdown}
                viewMode={viewMode}
                deleted={deleted}
              />
            )}
            <Dropdown
              className="Buyer-info_column_item"
              dropdownType="multiple"
              data={data}
              optionsType="market"
              value={data.MARKET}
              valueKey="MARKET"
              label="Market"
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            <DualRange
              className="Buyer-info_column_item"
              minValue={data.PRICE_MIN}
              maxValue={data.PRICE_MAX}
              minName="PRICE_MIN"
              maxName="PRICE_MAX"
              valueType="integer"
              label="Price Range"
              handleParentChange={handleChangeInput}
              viewMode={viewMode}
              deleted={deleted}
              isDollar
            />
            <DualRange
              className="Buyer-info_column_item"
              minValue={data.CAP_RATE_MIN}
              maxValue={data.CAP_RATE_MAX}
              minName="CAP_RATE_MIN"
              maxName="CAP_RATE_MAX"
              valueType="percent"
              label="Cap Rate Range"
              handleParentChange={handleChangeInput}
              viewMode={viewMode}
              deleted={deleted}
            />
            <SelectTeam
              className="Buyer-info_column_item"
              value={data.STRIVE_AGENT}
              valueKey="STRIVE_AGENT"
              label="Agent"
              data={data}
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            <Textarea
              className="Buyer-info_column_item"
              label="Notes"
              name="NOTES"
              value={data.NOTES}
              maxWidth="100%"
              handleParentChange={handleChangeInput}
              viewMode={viewMode}
              deleted={deleted}
            />
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default BuyerInfo;
